import request from '@/config'
import { DeptDtoBase, DeptSearchDto, DeptDeleteDto } from './dtos'

enum Apis {
    'Create' = `/api/basdepartment/insertbasdepartment`,              // 创建公司数据
    'Modify' = `/api/basdepartment/updatebasdepartment`,              // 修改公司数据
    'List' = `/api/basdepartment/getdepartmentpage`,
    'Detail' = `/api/basdepartment/getbasdepartmentinfo`,
    'Delete' = `/api/basdepartment/deletebasdepartment`,
    'DropDownTreeList' = `/api/basdepartment/gettreedropdownlist`
}

const GetDeptListApi = (search: DeptSearchDto): Promise<IResponse> => {
    return request.post({ url: Apis.List, data: search })
}

const GetDeptDetailApi = (rowId: string): Promise<IResponse> => {
    return request.post({ url: Apis.Detail, data: { id: rowId } })
}

const CreateDeptApi = (input: DeptDtoBase): Promise<IResponse> => {
    return request.post({ url: Apis.Create, data: input })
}

const ModifyDeptApi = (input: DeptDtoBase): Promise<IResponse> => {
    return request.post({ url: Apis.Modify, data: input })
}

const DelDeptApi = (input: DeptDeleteDto): Promise<IResponse> => {
    return request.post({ url: Apis.Delete, data: input })
}

const GetDeptCascaderTreeApi = (cmpId: string): Promise<IResponse> => {
    return request.post({ url: Apis.DropDownTreeList, data: { pid: cmpId } })
}

export {
    GetDeptListApi,
    GetDeptDetailApi,
    CreateDeptApi,
    ModifyDeptApi,
    DelDeptApi,
    GetDeptCascaderTreeApi,
}

